import { CommonSystemBridge } from '@lg/shared'

export class FrontendSystemBridge extends CommonSystemBridge {}
